import css from "styled-jsx/css";
import colors from "/styles/colors";

import { MOBILE_QUERY_MAX_WIDTH, SMALL_MOBILE_QUERY_MAX_WIDTH } from "/constants/vp-sizes";

export default css`
  .asset-strip-component {
    position: relative;
    width: 100vw;
    max-width: 100%;

    overflow: hidden;

    :global(img) {
      min-width: 100%;
    }
  }

  .asset-strip-content {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    text-align: center;

    .strip-signup-wrapper {
      margin-top: 32px;
    }

    .strip-title {
      color: ${colors["white"]};
      font-size: 48px;
      font-weight: 700;

      margin-bottom: 24px;
      padding: 0 48px;
    }

    .strip-subtitle {
      color: ${colors["white"]};
      font-size: 24px;

      margin-bottom: 24px;
      padding: 0 48px;
    }
  }

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH}) {
    .asset-strip-component {
      .asset-strip-content {
        .strip-title {
          font-size: 40px;

          margin-bottom: 24px;
          padding: 0 24px;
        }

        .strip-subtitle {
          font-size: 24px;

          margin-bottom: 24px;
          padding: 0 24px;
        }
      }
    }
  }

  @media (max-width: ${SMALL_MOBILE_QUERY_MAX_WIDTH}) {
    .asset-strip-component {
      .asset-strip-content {
        .strip-title {
          font-size: 32px;
        }

        .strip-subtitle {
          font-size: 20px;
        }
      }
    }
  }
`;
